import { GlobalNav } from "@/patterns/global-nav/src/index.tsx";
import { CollectionsCompoundSubNavProps } from "@/templates/collections/collections-compound-nav-props.tsx";

export const TeamworkCollectionNavbar = () => {
    return (
        <GlobalNav
            productKey={"home"}
            compoundNav={{
                ...CollectionsCompoundSubNavProps(),
                ctaUrl: "/collections/teamwork#contact"
            }}
        />
    );
};
